import React from 'react';

import * as S from './GradientBar.styles';

export interface GradientBarProps {
  height?: string;
  variant?: 'loop' | 'progress';
  durationMs?: number;
  className?: string;
}

export const GradientBar = ({
  height = '2px',
  variant = 'loop',
  durationMs = 10000,
  className,
}: GradientBarProps) => {
  if (variant === 'progress') {
    return (
      <S.ProgressGradientBar
        className={className}
        $height={height}
        $durationMs={durationMs}
      />
    );
  }

  return <S.StyledGradientBar className={className} $height={height} />;
};
